<template>
  <span>{{ i18nLang }}</span>
</template>

<script>
import { getLanguageText } from 'src/plugins/i18n'

export default {
  name: 'AgLanguageText',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    i18nLang () {
      return getLanguageText(this.value)
    },
  },
}
</script>
